// extracted by mini-css-extract-plugin
export default {"content":"sR-z","lookName":"tR-z","shopTheLookContainer":"uR-z","productContainer":"vR-z","imageContainer":"wR-z","mainImage":"xR-z"};